module.exports = __webpack_public_path__ + "img/180.9e484dec.jpg";